"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGS = void 0;
const gs = require("..");
const WrapperGS_1 = require("./WrapperGS");
/**
 * Шаблон имеющий data-tmpl-name (TagDataTemplateName) доступен для создания по имени. Шаблоны без имени могут быть созданы только передачей эталонного элемента в конструктор
 * Все шаблоны тега template - шаблон верхнего уровня.
 * Допускается создавать шаблоны вложенные в другие шаблоны.
 * Вложенные шаблоны - любога тега кроме template, при заполнении попадают в controls.
 * Вложенные шаблоны верхнего уровня будут удаляться при заполнении шаблона. Но они будут доступны к созданию по имени.
 * Если нужно поменять конечный тег для тега template используем data-tmpl-tag(TagDataTemplateTag).
 * */
class TemplateGS extends WrapperGS_1.WrapperGS {
    static GetTmpl(tmplName) {
        var _a;
        if (!TemplateGS._Inited) {
            for (const wrTmpl of gs.q('template').all) {
                const tName = (_a = wrTmpl.getGSA(TemplateGS.TagGSATemplateName)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                if (!tName)
                    continue;
                TemplateGS._TmplHTMLs.set(tName, wrTmpl);
            }
            TemplateGS._Inited = true;
        }
        let wr = TemplateGS._TmplHTMLs.get(tmplName);
        if (!wr) {
            wr = gs.q('template').all.filter((w) => { return (w.getGSA(TemplateGS.TagGSATemplateName).toLowerCase() === tmplName); })[0];
        }
        if (!wr) {
            wr = gs.q('.' + WrapperGS_1.WrapperGS.ClassNameTemplate).all.filter((w) => { return (w.getGSA(TemplateGS.TagGSATemplateName).toLowerCase() === tmplName); })[0];
        }
        if (!wr)
            throw new Error(`Cant create template with name ${tmplName}!`);
        TemplateGS._TmplHTMLs.set(tmplName, wr);
        return wr;
    }
}
exports.TemplateGS = TemplateGS;
TemplateGS.TagGSATemplateName = 'tmpl';
TemplateGS.TagGSATemplateTag = 'tmpl-tag';
TemplateGS.AttrGSControlName = 'ctrl';
//Содержит типизированные конструкторы. Заполняется ими из кодосгенерированной части шаблонов.
TemplateGS.Constructors = new Map();
TemplateGS._TmplHTMLs = new Map();
TemplateGS._Inited = false;
//# sourceMappingURL=TemplateGS.js.map